import { useHistory } from 'react-router-dom';
import { authorizationApi, SocialsProps } from '../services/apiServices/user/authorization';
import { useAppDispatch } from './redux';
import { authSlice } from '../store/reducers/AuthSlice';
import { useCustomSnackbar } from './useCustomEnqueueSnackbar';
import { getErrorMessage } from '../utils';

interface Location {
  pathname: string;
  search: string;
}

export const useSocialAuthorization = (location?: Location) => {
  const [googleAuthAPI] = authorizationApi.useLoginWithSocialMutation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { setCredentials } = authSlice.actions;
  const { customEnqueueSnackbar } = useCustomSnackbar();

  const socialAuth = async (props: SocialsProps) => {
    try {
      await googleAuthAPI(props)
        .unwrap()
        .then((credentials) => {
          dispatch(
            setCredentials({
              accessToken: credentials.access_token,
              refreshToken: credentials.refresh_token,
            }),
          );
          history.replace(`${location?.pathname}${location?.search}`);
        });
    } catch (err) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  return { socialAuth };
};
